import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutContent from '../components/AboutContent';
import './About.css';

const About = () => {
  return (
    <div className="about-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <AboutContent />
      <Footer />
    </div>
  );
};

export default About;